<div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0" *ngIf="caData">
  <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
    <div class="uk-grid-small uk-flex-middle uk-grid">
      <div class="uk-width-expand uk-width-5-6">
        <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
          Chiffre d'affaires
        </h3>
      </div>
      <div class="info primary-color uk-width-1-6 k-text-right">
        <i
          class="k-icon k-i-info"
          uk-tooltip="Il s’agit du chiffre d’affaires des sessions en fonction des filtres appliqués.<br>
          Notez que le statut des sessions évoluant dans le temps, les données peuvent varier en fonction du moment de la consultation de l’indicateur. Notez également que les données sont calculées au prorata des dates de formation incluses dans la période filtrée.<br>
          Masquez/affichez cet indicateur sur l’extranet de l’intervenant à l’aide du switch situé en haut à droite de la tuile."
        ></i>
      </div>
    </div>
  </div>
  <div class="uk-card-body uk-padding-small">
    <p class="margin-left-12">
      <span class="stats-number-before" *ngIf="isInter">{{ parseToNumber(caData.ca) | number: '2.0':'fr' }} </span>
      <span class="stats-number-after" *ngIf="isInter">{{ indicator ? '€ NET' : '€ HT' }}</span>
    </p>

    <p class="stats-sub-title" *ngIf="!isInter">Montant</p>
    <p>
      <span class="stats-number-before" *ngIf="!isInter">
        {{ parseToNumber(caData.ca) | number: '0.0':'fr' }}
      </span>
      <span class="stats-number-after" *ngIf="!isInter">{{ indicator ? '€ NET' : '€ HT' }}</span>
    </p>
    <p class="stats-sub-title" *ngIf="!isInter">CA/stagiaire</p>
    <p *ngIf="!isInter">
      <span class="stats-number-before" *ngIf="!isInter"
        >{{ parseToNumber(caData.ca, caData.dataApp.nbApp) | number: '0.2' }}
      </span>
      <span class="stats-number-after" *ngIf="!isInter">{{ indicator ? '€ NET' : '€ HT' }}</span>
    </p>
  </div>
</div>
